import api from "@/utils/http";

/**
 功能：
 time: 2026/1/5 11:06
 **/
export function getBuyerConfig() {
    return api.get('/partner/buyer/getSetConfig')
}

/**
 功能：
 time: 2026/1/5 11:42
 **/
export function getBuyerList(data) {
    return api.post('/partner/buyer/getList', data)
}

/**
 功能：
 time: 2026/1/5 14:50
 **/
export function getBuyerDetail(buyer_id) {
    return api.post('/partner/buyer/getDetail', {buyer_id })
}


/**
 功能：
 time: 2025/12/25 16:02
 **/
export function getBuyerSelectList(data) {
    return api.post('/partner/buyer/getSearchList',data)
}

/**
 功能：
 time: 2025/12/27 09:15
 **/
export function getBuyerAccount(buyer_id) {
    return api.post('/partner/buyer/getAccount', {buyer_id })
}

/**
 功能：
 time: 2026/4/3 17:34
 **/
export function examineBuyer(data) {
    return api.post('/partner/buyer/examineSave', data)
}


